<section class="ut-dash-card" aria-labelledby="dashboardCompletionTitle">
  <h2 class="ut-dash-card__heading" id="dashboardCompletionTitle">Profile Completion</h2>
  <div class="completion__graph" role="img" [attr.aria-label]="'Your profile is ' + percent + '% complete'">
    <svg class="completion__ring" [attr.viewBox]="'0 0 ' + size + ' ' + size" aria-hidden="true">
      <circle class="completion__track" [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" [attr.stroke-width]="stroke"
        [attr.stroke-dasharray]="arc" stroke-linecap="round" [attr.transform]="'rotate(90 ' + center + ' ' + center + ')'" />
      <circle class="completion__value" [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" [attr.stroke-width]="stroke"
        [attr.stroke-dasharray]="arc" [attr.stroke-dashoffset]="dashOffset" stroke-linecap="round"
        [attr.transform]="'rotate(90 ' + center + ' ' + center + ')'" />
    </svg>
    <img class="completion__avatar" [src]="user.avatar_url" alt="" />
    <span class="completion__badge" aria-hidden="true">{{ percent }}%</span>
  </div>
  <div class="completion__action">
    <a class="ut-btn" [href]="testerAppUrl + '/account/my-profile/'">Complete my profile</a>
  </div>
</section>
